import { useIntl } from 'react-intl';
import { MaterialClassId, MaterialId } from '@core/constants/Material';
import Grid from '@ui/Grid';
import Card from '@ui/Card';
import CardContent from '@ui/CardContent';
import { lightGreyColor } from '@ui/styles/colors';
import { IFormFieldRecapMaterialComponentProperties } from './types';
import { materialCategoryThumbnails, materialClassThumbnails, materialThumbnails } from '../../../constants/MaterialThumbnails';
import FormFieldRecapItem from './FormFieldRecapItem';
import { recapCardContentStyle, recapGridItemStyle, recapCardStyle } from './styles';

const FormFieldRecapItemMaterial = ({ fieldMaterial, fieldKey, inverted }: IFormFieldRecapMaterialComponentProperties) => {
    const intl = useIntl();

    return fieldMaterial.material !== null ? (
        <Grid item style={recapGridItemStyle}>
            <Card elevation={0} style={{ ...recapCardStyle, ...(inverted && { backgroundColor: lightGreyColor }) }}>
                <CardContent style={recapCardContentStyle}>
                    <FormFieldRecapItem
                        label={intl.formatMessage({ id: `fieldsChat.${fieldKey}.label` })}
                        value={intl.formatMessage({
                            id: fieldMaterial.material !== MaterialId.Other
                                ? `materials.${fieldMaterial.material}.name`
                                : (fieldMaterial.materialClass !== MaterialClassId.Other
                                    ? `materialClasses.${fieldMaterial.materialClass}.name`
                                    : `materialCategories.${fieldMaterial.materialCategory}.name`),
                        })}
                        thumbnail={fieldMaterial.material !== MaterialId.Other
                            ? materialThumbnails[fieldMaterial.material]
                            : (fieldMaterial.materialClass && fieldMaterial.materialClass !== MaterialClassId.Other
                                ? materialClassThumbnails[fieldMaterial.materialClass]
                                : fieldMaterial.materialCategory && materialCategoryThumbnails[fieldMaterial.materialCategory])}
                    />
                </CardContent>
            </Card>
        </Grid>

    ) : (<div />);
};

export default FormFieldRecapItemMaterial;
